import _routes from './routes';
import _CoreAndCatchUpListView from './component';

export const routes = _routes;
export const CoreAndCatchUpListView = _CoreAndCatchUpListView;



// WEBPACK FOOTER //
// ./containers/Group/WritingAssignment/CoreAndCatchUp/index.js